import React from "react";
import { useEffect } from "react";
import Riwayat from "../../components/Pinjam/Riwayat";

const RiwayatPinjam = () => {
  useEffect(() => {
    document.title = "Si TASIK - Riwayat";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-6">
      <Riwayat/>
    </div>
  );
};

export default RiwayatPinjam;
